/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotosize3Inputs */

const en_aiflowphotosize3 = /** @type {(inputs: Aiflowphotosize3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const de_aiflowphotosize3 = /** @type {(inputs: Aiflowphotosize3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Aiflowphotosize3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotosize3 = /** @type {((inputs?: Aiflowphotosize3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotosize3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotosize3(inputs)
	return de_aiflowphotosize3(inputs)
});
export { aiflowphotosize3 as "aiFlowPhotoSize" }